export default __webpack_public_path__ + "/assets/background-family.jpg";